/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { normalizeStoreTokenPath } from '@/data/utils/normalizeStoreTokenPath';
import { ALLOWED_CANONICAL_STATIC_ROUTES } from '../constants/pageDataFromId';
import { PAGE_TYPES } from '../constants/layout';

type TranslatedRoutes = ReturnType<typeof useLocalization<'Routes'>>;

export const buildCanonicalUrl = ({
	path,
	locale,
	urlKeywordName,
	staticRoutes,
	pageType
}: {
	path: string[] | string | undefined;
	locale: string;
	urlKeywordName?: string;
	staticRoutes: TranslatedRoutes;
	pageType?:string
}) => {
	const localePath = `/${locale}`;
	const router = useNextRouter();
	
	let appendUrl = '';
	if(router.query.offset && router.query.offset !== "0"){
		appendUrl="?offset="+router.query.offset
	}
	const normalizedPath = 
		pageType===PAGE_TYPES.ProductPage?
			[normalizeStoreTokenPath({ path, storeUrlKeyword: urlKeywordName })]
			.flat()
			.filter(Boolean).at(-1)??''
			:
			[normalizeStoreTokenPath({ path, storeUrlKeyword: urlKeywordName })]
			.flat()
			.filter(Boolean).join('/');
	
	let found = false;
	if(!ALLOWED_CANONICAL_STATIC_ROUTES.includes(normalizedPath)){
		found = Object.entries(staticRoutes).some(
			([_, value]) =>
				typeof value === 'object' && normalizedPath && value.route.t() === normalizedPath
		);
	}
	if (found) {
		// static route doesn't need
		return '';
	} else {
		let canonicalPath = `${normalizedPath ? '/' + normalizedPath : ''}`;
		if(appendUrl) canonicalPath = canonicalPath+appendUrl;
		return canonicalPath ;
	}
};
